/* eslint-disable @typescript-eslint/no-unused-vars */
import { createTheme } from '@mui/material/styles';

const materialTheme = createTheme({
  palette: {
    text: {
      primary: '#042765',
      secondary: '#365284',
      disabled: '#A1AFC5',
    },
    primary: {
      light: '#F7F9FE',
      main: '#1F2B58',
      dark: '#121822',
      contrastText: '#E6E9F0',
    },
    secondary: {
      main: '#EEAE1C',
      light: '#FFF4E6',
      dark: '#FE8C00',
    },
    action: {
      active: '#3E75FF',
      disabled: '#E7EEFF',
      disabledBackground: '#9EBAFF',
      focus: '#8BACFF',
    },
    error: {
      main: '#EF2C1C',
      light: '#FEEBE9',
    },
    info: {
      main: '#13B473',
      light: '#E8F8F2',
      dark: '#2e7d32',
    },
  },
  typography: {
    fontFamily: 'SourceSansPro',
    body1: {
      lineHeight: '1',
    },
    body2: {
      lineHeight: '1',
    },
    h4: {
      fontSize: '2rem',
      lineHeight: '1',
      fontWeight: 600,
    },
    h5: {
      lineHeight: '1',
      fontWeight: 600,
    },
    h6: {
      lineHeight: '1',
      fontWeight: 600,
    },
    caption: {
      fontSize: '13px',
      lineHeight: '1',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#F7F9FE',
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#EEAE1C',
          borderRadius: '4px',
          width: 'fit-content',
          '&:hover': {
            backgroundColor: '#EEAE1C',
          },
        },
        text: {
          padding: '16px',
          fontWeight: 600,
          fontSize: '16px',
          lineHeight: 1,
          color: '#1F2B58',
          textTransform: 'none',
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        colorPrimary: {
          color: '#3E75FF',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: '#E6E9F0',
          border: 'none',
          minHeight: '1px',
        },
        vertical: {
          backgroundColor: '#ffffff',
          borderRight: '2px solid #E6E9F0',
        },
      },
    },
    MuiInput: {
      defaultProps: {
        disableUnderline: true,
        placeholder: '#A1AFC5',
      },
      styleOverrides: {
        root: {
          border: '1px solid #E6E9F0',
          borderRadius: '4px',
          color: '#365284',
          fontSize: '14px',
          lineHeight: '14px',
        },
        input: {
          minHeight: '50px',
          padding: '0px 8px',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#121822',
          color: '#FFFFFF',
          borderRadius: '2px',
          padding: '8px 16px',
          marginTop: '0px',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: 'none',
          border: '1px solid #E6E9F0',
          borderRadius: '4px',
        },
      },
    },
    MuiMenu: {
      defaultProps: {
        marginThreshold: 56,
      },
      styleOverrides: {
        paper: {
          marginTop: '56px',
          maxHeight: '30%',
        },
        list: {
          padding: '0px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: '#A1AFC5',
        },
        select: {
          padding: '0px 8px',
          minHeight: '50px',
          backgroundColor: 'white',
          borderRadius: '4px',

          '&:focus': {
            backgroundColor: 'white',
            borderRadius: '4px',
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        padding: {
          padding: '0px',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          '& .Mui-selected': {
            backgroundColor: '#E2EAFF',
            '&:hover': {
              backgroundColor: '#E2EAFF',
            },
          },
        },
        button: {
          backgroundColor: '#white',
          '&:hover': {
            backgroundColor: '#E2EAFF',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paperWidthSm: {
          maxWidth: '800px',
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiTextField: {
      defaultProps: {
        InputLabelProps: {
          shrink: true,
        },
      },
    },
  },
});

export default materialTheme;
